export const DEFAULT_LOCALE = 'nl';
